import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxTrunkIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M20.1648 6.616C19.4792 5.8632 18.5824 5.5528 17.7272 5.6736H10.7392V4.3136C10.7392 3.4336 10.0232 2.7168 9.14239 2.7168H4.13519C3.25519 2.7168 2.53839 3.4328 2.53839 4.3136V9.3208C2.53839 10.2008 3.25439 10.9176 4.13519 10.9176H8.06319L9.80079 12.9776H4.31279V17.672C4.31279 19.6848 5.94479 21.3168 7.95759 21.3168H17.2C18.2792 21.3168 19.1536 20.4424 19.1536 19.3632V13.1912L20.352 11.6624C21.4784 10.2256 21.3952 7.9664 20.1656 6.6168L20.1648 6.616ZM11.456 6.4608H16.1776C16.08 6.5568 15.9872 6.6608 15.8984 6.7736L14.384 8.7056H10.7408V6.4608H11.4568H11.456ZM3.34159 9.3208V4.3136C3.34159 3.8752 3.69839 3.5184 4.13679 3.5184H9.14399C9.58239 3.5184 9.93919 3.8752 9.93919 4.3136V9.3208C9.93919 9.7592 9.58239 10.116 9.14399 10.116H4.13679C3.69839 10.116 3.34159 9.7592 3.34159 9.3208ZM9.09439 10.9176H9.14319C9.96559 10.9176 10.644 10.2928 10.7304 9.4928H12.4904L10.2912 12.336L9.09439 10.9176ZM12.7968 20.528H7.95679C6.37839 20.528 5.09919 19.2488 5.09919 17.6704V13.7632H12.796V20.5272L12.7968 20.528ZM10.7904 12.9768L13.4856 9.4928H14.7648L17.9392 12.9768H10.7904ZM18.3656 19.3624C18.3656 20.0064 17.8432 20.5288 17.1992 20.5288H13.6128V13.7648H18.3648V19.3624H18.3656ZM19.8216 11.08L18.6376 12.5904L15.2448 8.8664L16.4288 7.356C17.2872 6.2616 18.7424 6.2072 19.68 7.236C20.6168 8.2648 20.6808 9.9856 19.8224 11.08H19.8216Z"
            fill="#222"
          />
          <path
            d="M8.35119 6.536L7.50959 6.0752C7.45599 6.0456 7.41119 6.0016 7.38239 5.948L6.92159 5.1064C6.79999 4.884 6.48079 4.884 6.35919 5.1064L5.89839 5.948C5.86879 6.0016 5.82479 6.0464 5.77119 6.0752L4.92959 6.536C4.70719 6.6576 4.70719 6.9768 4.92959 7.0984L5.77119 7.5592C5.82479 7.5888 5.86959 7.6328 5.89839 7.6864L6.35919 8.528C6.48079 8.7504 6.79999 8.7504 6.92159 8.528L7.38239 7.6864C7.41199 7.6328 7.45599 7.588 7.50959 7.5592L8.35119 7.0984C8.57359 6.9768 8.57359 6.6576 8.35119 6.536Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
